import { render, staticRenderFns } from "./WidgetCarouselTextSettings.vue?vue&type=template&id=5073d72f&scoped=true"
import script from "./WidgetCarouselTextSettings.vue?vue&type=script&lang=js"
export * from "./WidgetCarouselTextSettings.vue?vue&type=script&lang=js"
import style0 from "./WidgetCarouselTextSettings.vue?vue&type=style&index=0&id=5073d72f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5073d72f",
  null
  
)

export default component.exports